import React, { useState } from "react";
import countries from "../Components/countries";
import swal from "sweetalert";
import { app } from '../firebase.js';
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import UbunifuNavbar from "../Components/UbunifuNavbar";
import heroImage from '../Images/fatima.jpg'
import { ToastContainer, toast, Bounce } from 'react-toastify';


function Home() {
  const [name, setName] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [help, setHelp] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const db = getFirestore(app);
  const auth = getAuth();


  const handleCountryChange = (e) => {
    const countryValue = e.target.value;
    setSelectedCountry(countryValue);

    const country = countries.find((c) => c.value === countryValue);
    if (country && country.code) {
      setPhone(country.code + " ");
    }
  };

  const handleDateChange = (e) => {
    const chosenDate = new Date(e.target.value);
    const day = chosenDate.getUTCDay();
    if (day === 0 || day === 6) {
      swal("Info", "Please select a weekday (Monday to Friday)", "info");
      setDate("");
    } else {
      setDate(e.target.value);
    }
  };

  const handleTimeChange = (e) => {
    const chosenTime = e.target.value;
    if (chosenTime < "08:00" || chosenTime > "22:00") {
      swal("Info", "Please select a time between 08:00 and 22:00.", "info");
      setTime("");
    } else {
      setTime(chosenTime);
    }
  };


  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      setUser(result.user); // store signed-in user
      //swal("Signed In", `Welcome ${result.user.displayName}`, "success");
    } catch (error) {
      swal("Error", error.message, "error");
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !selectedCountry || !email || !phone || !help || !date || !time) {
      swal("Error", "Please fill in all fields", "error");
      return;
    }

    setLoading(true);

    try {

      // 1. Sign in with Google if not signed in
      let currentUser = user;
      if (!currentUser) {
        const provider = new GoogleAuthProvider();
        const result = await signInWithPopup(auth, provider);
        currentUser = result.user; // use this for Firestore
        setUser(currentUser);
      }

      const token = await currentUser.getIdToken();

      toast.success("Authenticated")
      toast.info("Creating a meeting room...")

      // Create Daily.co room
      const response = await fetch("https://api.daily.co/v1/rooms", {
        method: "POST",
        headers: {
          'Authorization': 'Bearer 6d2c812fd8383e038f1b5009df0756b7844676ba991f2d74bf6820cf61526212', // Replace with your Daily.co API key

          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          properties: {
            enable_screenshare: true,
            enable_chat: true,
            start_video_off: true,
            start_audio_off: false,
          },
        }),
      });

      const room = await response.json();
      if (!room.name) {
        swal("Error", "Failed to create video room", "error");
        return;
      }

      toast.info("submitting details...")

      // Save to Firebase
      // 2. Save to Firestore
      const callDoc = await addDoc(collection(db, "scheduledCalls"), {
        name,
        email,
        phone,
        country: selectedCountry,
        help,
        date,
        time,
        roomId: room.name,
        roomUrl: room.url,
        createdBy: currentUser.uid,
        timestamp: serverTimestamp(),
      });

      // 3. Format calendar link
      const startDate = new Date(`${date}T${time}`);
      const endDate = new Date(startDate.getTime() + 15 * 60000); // +15 mins

      const formatDate = (d) => {
        return d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
      };

      const linkUrl = `https://meet.ubunifucollege.com/ref?id=${callDoc.id}`;

      const calendarLink = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=15+Minute+Call&dates=${formatDate(startDate)}/${formatDate(endDate)}&details=Join+here:+${linkUrl}&location=Online`;

      // 4. Build email content
      const emailSubject = "YOUR 15 MINUTE CALL IS SCHEDULED";
      const emailMessage = `
        Hi ${name},<br><br>

        Your 15 minute video call with the Ubunifu team has been successfully scheduled.<br><br>

        <b>Date:</b> ${date}<br>
        <b>Time:</b> ${time}<br><br>

        <b>Join the call:</b><br>
        <a href="${linkUrl}">${linkUrl}</a><br><br>

        You can add this meeting to your calendar using the link below:<br>
        <a href="${calendarLink}">Add to Google Calendar</a><br><br>

        If there is anything specific you would like us to prepare in advance, feel free to reply to this email.<br><br>

        Best regards,<br>
        <b>Ubunifu Team</b><br>
        Ubunifu College
      `;

      toast.info("sending email..")
      await fetch("https://us-central1-ubunifu-college.cloudfunctions.net/lab/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          email: email,
          subject: emailSubject,
          message: emailMessage,
        }),
      });


      // 5. Send SMS if Kenya
      if (selectedCountry === "kenya") {
        toast.info("Sending SMS...")
        const smsMessage = `Your 15 minute call is confirmed on ${date} at ${time}. Join here: ${linkUrl}`;

        await fetch("https://us-central1-ubunifu-college.cloudfunctions.net/lab/send-sms", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            phoneNumber: phone,
            message: smsMessage,
          }),
        });
      }


      //toast.success("Welcome")

      swal("Success", "Call scheduled successfully!", "success").then(() => {
        window.location.href = calendarLink;
      })

      // Reset form
      setName("");
      setSelectedCountry("");
      setEmail("");
      setPhone("");
      setHelp("");
      setDate("");
      setTime("");
    } catch (error) {
      swal("Error", error.message, "error");
    }
  };

  return (
    <div>
      <UbunifuNavbar />
      <div className="container mainHero">

        <div className="heroLeft">
          <h1>We’ve been waiting for you!</h1>
          <p>Book a quick 15-minute video call with our team. Tell us what you want to build or the kind of support you need. Whether you’re starting a new product, hiring an engineering team, or scaling your startup, this is where we begin.</p>

          <div className="leftHeroImage">
            <img src={heroImage} alt="" />
          </div>
        </div>

        <div className="heroRight">
          {/* <h2 className="mb-4 text-center">Schedule a 15 Minute Call</h2> */}
          <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>


            {/* Name */}
            <div className="mb-3">
              <label htmlFor="name" className="form-label">Your Name</label>
              <input
                type="text"
                className="form-control"
                id="name"
                placeholder="Enter your full name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            {/* Country */}
            <div className="mb-3">
              <label htmlFor="country" className="form-label">Select Your Country</label>
              <select
                className="form-select"
                id="country"
                value={selectedCountry}
                onChange={handleCountryChange}
                required
              >
                <option value="">Choose...</option>
                {countries.map((country) => (
                  <option key={country.value} value={country.value}>
                    {country.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Email */}
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Your Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {/* Phone */}
            <div className="mb-3">
              <label htmlFor="phone" className="form-label">Your Phone Number</label>
              <input
                type="tel"
                className="form-control"
                id="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="+254 700 000000"
                required
              />
            </div>

            {/* Help */}
            <div className="mb-3">
              <label htmlFor="help" className="form-label">What do you want help with?</label>
              <select
                className="form-select"
                id="help"
                value={help}
                onChange={(e) => setHelp(e.target.value)}
                required
              >
                <option value="">Choose...</option>
                <option value="Startup Co-Creation">Startup Co-Creation</option>
                <option value="Hire Engineering Teams">Hire Engineering Teams</option>
                <option value="Product Development">Product Development</option>
                <option value="Hire Dedicated Expert">Hire Dedicated Expert</option>
                <option value="Hire Paid Interns">Hire Paid Interns (Junior Devs)</option>
                <option value="other">Other</option>
              </select>
            </div>

            {/* Date */}
            <div className="mb-3">
              <label htmlFor="date" className="form-label">Select Date</label>
              <input
                type="date"
                className="form-control"
                id="date"
                value={date}
                onChange={handleDateChange}
                required
              />
            </div>

            {/* Time */}
            <div className="mb-3">
              <label htmlFor="time" className="form-label">Select Time</label>
              <input
                type="time"
                className="form-control"
                id="time"
                value={time}
                onChange={handleTimeChange}
                required
              />
              <div className="form-text">Calls are 15 minutes (08:00–22:00, Mon–Fri)</div>
            </div>


            <button
              type="submit"
              className="btn btn-dark w-100"
              disabled={loading}
            >
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : null}
              {loading ? "Scheduling..." : "Schedule a 15 Minute Video Call"}
            </button>
          </form>
        </div>


        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          transition={Bounce}
        />
      </div>
    </div>

  );
}

export default Home;